export default "__VITE_ASSET__CTygjWSm__"